import { ANALYTICS_ALLOWED_ROLES, IT_TS_ALLOWED_ROLES, USER_MANAGEMENT_ALLOWED_ROLES } from '../services/clientAuth';

export const sidebarItems = [
    {
        id: 3,
        name: 'Канбан',
        link: '/board',
        way: '/board'
    },
    {
        id: 12,
        name: 'Чаты тикетов',
        link: '/it-ts',
        way: '/it-ts',
        allowedRoles: IT_TS_ALLOWED_ROLES
    },
    {
        id: 11,
        name: 'Чаты',
        link: '/chats',
        way: '/chats'
    },
    {
        id: 4,
        name: 'Пользователи',
        link: '/users',
        way: '/users',
        allowedRoles: USER_MANAGEMENT_ALLOWED_ROLES
    },
    {
        id: 5,
        name: 'Шаблоны',
        link: '/templates',
        way: '/templates'
    },
    {
        id: 6,
        name: 'Команда',
        link: '/team',
        way: '/team'
    },
    {
        id: 7,
        name: 'Синхронизация справочника',
        link: '/SuncSpravochnik',
        way: '/SuncSpravochnik'
    },
    {
        id: 8,
        name: 'Бэклог задач',
        link: '/ItBacklog',
        way: '/ItBacklog'
    },
    {
        id: 9,
        name: 'Профиль',
        link: '/profile',
        way: '/profile'
    },
    {
        id: 10,
        name: 'Аналитика',
        link: '/analytics',
        way: '/analytics',
        allowedRoles: ANALYTICS_ALLOWED_ROLES
    },
    {
        id: 13,
        name: 'Смены',
        link: '/shifts',
        way: '/shifts',
        allowedRoles: IT_TS_ALLOWED_ROLES
    }
];
